export default "__VITE_ASSET__CXDMIHiN__"